// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5H9.48063L11.4806 5H23V10.5218C21.9897 9.875 20.7886 9.5 19.5 9.5C15.9101 9.5 13 12.4101 13 16V21H1V2.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.75 14.75V15.5H23.999V22H14.999V15.5H16.25V14.75C16.25 12.9551 17.7051 11.5 19.5 11.5C21.2949 11.5 22.75 12.9551 22.75 14.75ZM20.75 14.75C20.75 14.0596 20.1904 13.5 19.5 13.5C18.8096 13.5 18.25 14.0596 18.25 14.75V15.5H20.75V14.75Z"}}]};

const FolderLockedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-locked-filled',
    ref,
    icon: element,
  },
));

FolderLockedFilledIcon.displayName = 'FolderLockedFilledIcon';

export default FolderLockedFilledIcon;
